"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VehicleGeometry;

var _coreUtils = _interopRequireDefault(require("@opentripplanner/core-utils"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLeaflet = require("react-leaflet");

var _ModeCircles = require("../markers/ModeCircles");

var _utils = require("../../utils");

/**
 * presentational component for rendering transit vehicle positions atop a map
 * will show both point positions for a collection of vehicles, as well as being
 * able to render a 'selected' vehicle
 */
function VehicleGeometry(props) {
  const {
    zoom,
    vehicle,
    isTracked,
    onVehicleClicked,
    onRecenterMap,
    color,
    highlightColor,
    MarkerSlot,
    PopupSlot,
    TooltipSlot
  } = props; // recenter the map to focus on selected vehicle

  if (isTracked && onRecenterMap) {
    // TODO: very leaflet specific - e.g., mb geo
    const {
      map
    } = (0, _reactLeaflet.useLeaflet)();
    onRecenterMap(map, vehicle.lat, vehicle.lon);
  }

  return /*#__PURE__*/_react.default.createElement(MarkerSlot, {
    zoom: zoom,
    vehicle: vehicle,
    isTracked: isTracked,
    onVehicleClicked: onVehicleClicked,
    color: color,
    highlightColor: highlightColor
  }, PopupSlot && /*#__PURE__*/_react.default.createElement(PopupSlot, {
    vehicle: vehicle,
    isTracked: isTracked
  }), TooltipSlot && /*#__PURE__*/_react.default.createElement(TooltipSlot, {
    vehicle: vehicle,
    isTracked: isTracked
  }));
}

VehicleGeometry.propTypes = {
  /** map zoom: is part of the props due to redrawing this layer on map zoom */
  zoom: _propTypes.default.number.isRequired,

  /** required vehicle record for the vehicle */
  vehicle: _coreUtils.default.types.transitVehicleType.isRequired,
  isTracked: _propTypes.default.bool,

  /** Callback fired when the vehicle is clicked (vehicle: object) => {} */
  onVehicleClicked: _propTypes.default.func,

  /** will pan the map to the coordinates of the selected vehicle */
  onRecenterMap: _propTypes.default.func,

  /**
   * A custom leaflet marker component with the signature
   * ({vehicle: object, onVehicleClicked: (vehicle) => {}, children: Element}) => Element
   */
  MarkerSlot: _propTypes.default.func,

  /** optional / customizable popup slot */
  PopupSlot: _propTypes.default.func,

  /** optional / customizable tooltip slot */
  TooltipSlot: _propTypes.default.func,

  /** fill color of a vehicle */
  color: _propTypes.default.string,

  /** fill color of a tracked vehicle (see isTracked above) */
  highlightColor: _propTypes.default.string
};
VehicleGeometry.defaultProps = {
  isTracked: false,
  onVehicleClicked: (vehicle, isTracked) => {
    (0, _utils.linterIgnoreTheseProps)(vehicle, isTracked);
  },
  onRecenterMap: null,
  MarkerSlot: _ModeCircles.CircledVehicle,
  PopupSlot: null,
  TooltipSlot: null,
  color: "",
  highlightColor: ""
};
//# sourceMappingURL=index.js.map